// extracted by mini-css-extract-plugin
module.exports = {"case__item":"CaseItem_case__item__3am9A"};